import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import find from 'lodash/find';
import { getCurrentCategory } from 'app/selectors/productSelector';
import { setProductFilterParams } from 'app/dispatcher/productDispatcher';
import { Modal } from 'app/seedly-component-library';
import Button from 'app/seedly-component-library/button-new';

import type { RootState } from 'app/reducer';
import analytics from 'app/utils/analytics';

function withModal(WrappedComponent) {
  const ModalHoc = props => {
    const { isOpen, onClose, withCloseButton, filterId } = props;
    const dispatch = useDispatch();

    const productFilterParams = useSelector(
      (state: RootState) => state.product.productFilterParams,
    );
    const currentCategory = useSelector(state => getCurrentCategory(state));
    const filters = get(currentCategory, 'filters', null);
    const filterItem = find(filters, { id: filterId });
    const [filterCheckList, setFilter] = useState([]);
    const [title, setTitle] = useState('');

    useEffect(() => {
      if (filterItem) {
        const filterParam = get(productFilterParams, `filter[${title}]`, []);
        setTitle(filterItem.title);
        setFilter(filterParam);
      }
    }, [filterItem, productFilterParams, title]);

    if (!filterItem) return null;

    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        withCloseButton={withCloseButton}
        onRequestClose={onClose}
        label="product-filter"
        headerTitle={`Filter ${title}`}
        mobileFullHeight
        footerStyle={{ padding: '16px' }}
        footer={
          <div className="w-full flex justify-end gap-2">
            <Button
              variant="outline"
              disabled={filterCheckList.length === 0}
              onClick={() => {
                analytics.trackResetFilter();
                setFilter([]);
              }}
            >
              Deselect All
            </Button>
            <Button
              onClick={() => {
                analytics.trackFilterApplied({
                  key: title,
                  value: title,
                  otherFilters: filterCheckList.map(f => ({
                    key: f,
                    value: f,
                  })),
                });
                dispatch(setProductFilterParams(title, filterCheckList));
                onClose();
              }}
            >
              Apply
            </Button>
          </div>
        }
      >
        <WrappedComponent
          setFilter={setFilter}
          filterCheckList={filterCheckList}
          {...props}
        />
      </Modal>
    );
  };

  return ModalHoc;
}

export default withModal;
